var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "13px",
    viewBox: "0 0 7 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "play") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Latest-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "play_button",
    transform: "translate(-40.000000, -32.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "play",
    transform: "translate(40.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ffwd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "FORWARD-BUTTON",
    points: "0 0 0 13 1.71311119 13 1.71311119 11.5767609 3.60587045 11.5767609 3.60587045 10.115559 5.2273647 10.115559 5.2273647 8.61432613 7 8.61432613 7 7.19655255 7 5.81231038 7 4.26233141 5.2273647 4.26233141 5.2273647 3.00556774 3.60587045 3.00556774 3.60587045 1.50005113 1.71311119 1.50005113 1.71311119 0"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.0214e13cb3559c5f947d0968753e5b37.svg";
export { ForwardRef as ReactComponent };